import { createClient } from '@atlassian/search-client/base-search-client';
import { Scope as JiraScope } from '@atlassian/search-client/jira/types';

import { PrimaryProductKeys } from '../../../../common/constants/primary-product-keys';
import type { UserDetailsWithPicture } from '../../../../common/constants/types';
import type {
	FilterSuggestionGroup,
	QuickFindResult,
} from '../../../../common/ui/quick-find/types';

export const fetchFilterSuggestions = async (
	user: UserDetailsWithPicture | undefined,
	cloudId: string | null | undefined,
): Promise<QuickFindResult<FilterSuggestionGroup>[]> => {
	const searchClient = createClient({
		cloudId: cloudId || '',
	});

	const searchProjectsResponse = await searchClient.search({
		query: '',
		resultLimit: 1,
		scopes: [JiraScope.JiraProject],
		analytics: {
			identifier: 'quick-find',
		},
	});

	const firstProject = searchProjectsResponse?.response.rawData.scopes?.[0]?.results?.[0];

	return [
		{
			id: 'product-filter',
			title: 'Suggested product filter',
			type: 'filter-suggestion',
			data: {
				product: {
					filterName: 'app',
					option: { value: PrimaryProductKeys.Jira, label: 'Jira' },
				},
				...(firstProject && {
					jProject: {
						filterName: 'project',
						option: { value: firstProject.id, label: firstProject.name },
					},
				}),
				...(user?.id && {
					jAssignee: {
						filterName: 'assignee',
						// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
						option: { value: user.id, label: user.name || 'me' },
					},
				}),
			},
		},
	];
};
